import React from "react";

import { makeStyles } from "tss-react/mui";

import { ClientCardFragment } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

import ClientCard from "./ClientCard";

const useStyles = makeStyles()({
  root: {
    backgroundColor: colors.white,
  },
});

type ClientListProp = {
  clients?: ClientCardFragment[] | null;
};

const ClientList: React.FC<ClientListProp> = ({ clients }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      {(clients ?? []).map((client) => (
        <ClientCard key={client.id} clientId={client.id} />
      ))}
    </div>
  );
};

export default ClientList;
